import dayjs from 'dayjs';

import { DateRangeInput } from '@anyx/common-graphql';


type Range = {
  from?: string;
  to?: string;
};

type GetDateRangeFiltersReturn = {
  deliveryDateRange?: DateRangeInput;
  deliveryDateRangeCompare?: DateRangeInput;
};

const DEFAULT_DATE_RANGE = {
  deliveryDateRange: undefined,
  deliveryDateRangeCompare: undefined,
};

/**
 *
 * Create date range filters for delivery dates
 * @param range
 * @returns {deliveryDateRange, deliveryDateRangeCompare}
 * */
export const getDateRangeFilters = (range?: Range): GetDateRangeFiltersReturn => {
  if (!range || !range.from || !range.to) {
    return DEFAULT_DATE_RANGE;
  }
  const fromDate = dayjs(range.from);
  const toDate = dayjs(range.to);

  if (!fromDate.isValid() && !toDate.isValid()) {
    return DEFAULT_DATE_RANGE;
  }

  const diff = toDate.diff(fromDate, 'day') + 1;

  const compareFromDate = fromDate.subtract(diff, 'day');
  const compareToDate = fromDate.subtract(1, 'millisecond');

  return {
    deliveryDateRange: {
      from: fromDate.toISOString(),
      to: toDate.toISOString(),
    },
    deliveryDateRangeCompare: {
      from: compareFromDate.toISOString(),
      to: compareToDate.toISOString(),
    },
  };
};
